import { render } from "./kickoff.vue?vue&type=template&id=b2bffa82"
import script from "./kickoff.vue?vue&type=script&lang=js"
export * from "./kickoff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__